var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCancel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50 50",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1541140"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 25 2 C 12.308594 2 2 12.308594 2 25 C 2 37.691406 12.308594 48 25 48 C 37.691406 48 48 37.691406 48 25 C 48 12.308594 37.691406 2 25 2 Z M 25 4 C 36.609375 4 46 13.390625 46 25 C 46 36.609375 36.609375 46 25 46 C 13.390625 46 4 36.609375 4 25 C 4 13.390625 13.390625 4 25 4 Z M 32.988281 15.988281 C 32.726562 15.992188 32.476562 16.101562 32.292969 16.292969 L 25 23.585938 L 17.707031 16.292969 C 17.519531 16.097656 17.261719 15.992188 16.992188 15.992188 C 16.582031 15.992188 16.21875 16.238281 16.0625 16.613281 C 15.910156 16.992188 16 17.421875 16.292969 17.707031 L 23.585938 25 L 16.292969 32.292969 C 16.03125 32.542969 15.925781 32.917969 16.019531 33.265625 C 16.109375 33.617188 16.382812 33.890625 16.734375 33.980469 C 17.082031 34.074219 17.457031 33.96875 17.707031 33.707031 L 25 26.414062 L 32.292969 33.707031 C 32.542969 33.96875 32.917969 34.074219 33.265625 33.980469 C 33.617188 33.890625 33.890625 33.617188 33.980469 33.265625 C 34.074219 32.917969 33.96875 32.542969 33.707031 32.292969 L 26.414062 25 L 33.707031 17.707031 C 34.003906 17.421875 34.09375 16.980469 33.9375 16.601562 C 33.777344 16.222656 33.402344 15.976562 32.988281 15.988281 Z M 32.988281 15.988281 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.607e9408e9299bce50a2d6b0788a2d49.svg";
export { ForwardRef as ReactComponent };